import { Component, Input, Output, EventEmitter, OnInit, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { PaginationInfo } from '../../../models';

@Component({
  selector: 'app-pagination',
  standalone: true,
  imports: [CommonModule, ButtonModule],
  templateUrl: './pagination.component.html',
  styleUrl: './pagination.component.scss'
})
export class PaginationComponent implements OnInit, OnChanges {
  @Input() paginationInfo!: PaginationInfo;
  @Output() pageChange = new EventEmitter<number>();

  ngOnInit() {
  }

  ngOnChanges() {
  }

  get visiblePages(): number[] {
    if (!this.paginationInfo) {
      return [];
    }
    
    const pages: number[] = [];
    const start = Math.max(1, this.paginationInfo.currentPage - 2);
    const end = Math.min(this.paginationInfo.totalPages, this.paginationInfo.currentPage + 2);

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  }

  onPageChange(page: number) {
    if (!this.paginationInfo || page < 1 || page > this.paginationInfo.totalPages) {
      return;
    }
    this.pageChange.emit(page);
  }

  onPreviousPage() {
    if (!this.paginationInfo || this.paginationInfo.currentPage <= 1) {
      return;
    }
    this.onPageChange(this.paginationInfo.currentPage - 1);
  }

  onNextPage() {
    if (!this.paginationInfo || this.paginationInfo.currentPage >= this.paginationInfo.totalPages) {
      return;
    }
    this.onPageChange(this.paginationInfo.currentPage + 1);
  }
}
